export function DataSciLogo({ small = false }: { small?: boolean }) {
  return (
    <span className={`datasci-logo${small ? " datasci-logo--small" : ""}`}>
      <svg role="img" aria-label="DataSci Editora" viewBox="315 256 2306 611" width="2306" height="611">
        <image href="/logos/datasci.png" width="4032" height="1209" />
      </svg>
    </span>
  );
}
